<template>
    <section>
        <div 
        class="modal align-middle" 
        tabindex="-1" 
        data-backdrop="static" 
        data-keyboard="false"  
        id="modal-cambio-estatus">
            <div class="modal-dialog" style="max-width: 90%;">
                <div class="modal-content">
                     <div class="modal-header">
                        <h5 class="modal-title">Informacion del aspirante</h5>
                        <button  id="btn-cerrar-modal-cambio-estatus" class="close" data-dismiss="modal">
                            <i class="fas fa-times-circle"></i>
                        </button>
                    </div> 
                    <div style="display: flex; flex-direction: row;">
                    <div class="modal-body pl-4 pr-4" style="width: 40%;">
                        <div class="form-group">
                            <div class="justify-content-center mb-3">
                                <div v-for="(item,index) in  aspiranteElegido.camposFormulario.filter(f => f.IdTipoCampo!=6)" :key="index"> 
                                <div class="caja-campos">
                                    <label style="display: block;">
                                        {{item.NombreDelCampo}}
                                    </label>
                                    <input v-if="item.IdTipoCampo==1 || item.IdTipoCampo==2 || item.IdTipoCampo==4 || item.IdTipoCampo==5 || item.IdTipoCampo==7" 
                                    type="text"  class='form-control' placeholder="Ingrese el título" 
                                    :value="item.Valor" disabled/>
                                    <textarea  v-if="item.IdTipoCampo==8" 
                                    class="form-control" cols="45" rows="5" 
                                    v-model="item.Valor" disabled></textarea>                                    
                                </div>
                            </div>
                            <div v-for="(item,index) in  aspiranteElegido.camposFormulario.filter(f => f.IdTipoCampo==6)" :key="'archivo'+index" 
                                style="display: inline-block;margin-right: 5px;width: 5rem;height: 8em; margin:1rem 1rem 0 0; border: solid black 3px; border-radius: 5px; text-align: center; overflow: hidden; background-color:#c0392b ;">
                                <label style="display: block;height: 3em; overflow: hidden;" :for="'boton'+index">
                                    {{item.NombreDelCampo}}
                                </label>
                                <button  v-if="item.IdTipoCampo==6" 
                                style="border-radius: 15%;display: inline-block; width: 80%;" 
                                :id="'boton'+index" 
                                v-on:click="rutaDocumentoParaVisor=item.Valor">
                                <i class="fa fa-file-pdf fa-3x" style="color: red"  aria-hidden="true"></i>
                               
                            </button>             
                            </div>
                            </div>                           
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1 acciones-activacion-contenidos">
                                <button type="button" class="btn btn-block btn-danger" 
                                v-on:click="cambiarEstado(aspiranteElegido.idAspiranteElegido,4)">
                                    <i class="fas fa-times"></i>&nbsp;&nbsp;Rechazar
                                </button></div>
                            <div class="col-6 pr-1 pl-1 acciones-activacion-contenidos">
                                <button type="button" class="btn btn-block btn-success" 
                                v-on:click="cambiarEstado(aspiranteElegido.idAspiranteElegido,2)">
                                    <i class="fas fa-save"></i>&nbsp;&nbsp;Aprobar
                                </button>
                            </div> 
                        </div>
                        <div class="row mt-4" v-if="aspiranteElegido.estadoDeAspirante!='Registrado'">
                        <p style="text-align:center;width: 100%;height:3em; border: solid 1px; border-radius: 10px;padding-top: .7em;" 
                        :class="(aspiranteElegido.estadoDeAspirante=='Aprobado')?'acceptado':'rechazado'">
                            <span style="margin-top: 1em;">El aspirante a sido marcado como {{aspiranteElegido.estadoDeAspirante}}</span>
                        </p>
                        </div>
                    </div>
                    <div style="width: 60%;background-color:#525659;"> 
                        <object style="width: 100%;height: 70vh;" 
                        :data="rutaDocumentoParaVisor"></object>
                    </div>  
                </div>           
                </div>
            </div>
        </div>
        <section id="encabezados">
            <h1>CONVOCATORIAS</h1>
            <h4>Seleccione la convocatoria necesaria para ver los aspirantes registrados</h4>           
        </section>
        <article>
            <FiltroConvocatorias v-on:MetodoPadre="ObtenerFiltros"></FiltroConvocatorias> 
        </article><br>
        <div id="caja-tabla" class="area">
            <button style="margin-top: 31px;"  type="button" class="btn btn-success ml-2" v-on:click="DescargarReporte"><i class="fas fa-file-excel" aria-hidden="true"  ></i>&nbsp;&nbsp;Descargar Reporte</button>
            <table
            class="table table-striped table-light table-hover"
            id="tabla-aspirantes"              
            data-toggle="table"
            data-pagination="true"
            data-undefined-text="Sin información"  
            data-page-size = "30"
            data-page-list="[5,10,20]"
            data-click-to-select="false"
            data-search="true">
                <thead class="thead-dark">
                    <tr>
                        <th 
                        data-halign="center" 
                        data-width="10" 
                        data-align="center" 
                        data-field="Folio" 
                        data-sortable="true">
                        Folio
                        </th>
                        <th 
                        data-halign="center" 
                        data-width="20" 
                        data-align="center" 
                        data-field="NombreConvocatoria"  
                        data-sortable="true">
                        Convocatoria
                        </th> 
                        <th 
                        data-halign="center" 
                        data-width="20" 
                        data-align="center" 
                        data-field="Categoria"  
                        data-sortable="true">
                        Categoria
                        </th>                                 
                        <th 
                        data-halign="center" 
                        data-width="20" 
                        data-align="center" 
                        data-field="Curp"  
                        data-sortable="true">
                        Curp
                        </th>
                        <th 
                        data-halign="center" 
                        data-width="20" 
                        data-align="center" 
                        data-field="FechaRegistro"  
                        data-sortable="true">
                        Fecha y Hora de Registro
                        </th>
                        <th 
                        data-halign="center" 
                        data-width="20" 
                        data-align="center" 
                        data-field="NombreDelAspirante" 
                        data-sortable="true">
                        Nombre Del Aspirante
                        </th>                             
                        <th 
                        data-halign="center" 
                        data-width="20" 
                        data-align="center" 
                        data-field="EstadoDelAspiranteFormato" 
                        data-sortable="true">
                        Estado del Aspirante
                        </th>                          
                        <th 
                        data-events="operateEvents" 
                        data-width="40"  
                        data-halign="center" 
                        data-align="center" 
                        :data-formatter="this.accionVerMas()">
                        Ver Mas
                        </th>
                        <!-- <th 
                        data-events="operateEvents" 
                        data-width="40"  
                        data-halign="center" 
                        data-align="center" 
                        data-field="EstaEditable.html">
                        Permitir Editar
                        </th>  -->
                    </tr> 
                </thead>
            </table>
        </div>
    </section>
</template>
<script>
import FiltroConvocatorias from '@/components/AdministradorConvocatorias/ConsultaConvocatorias/FiltroConvocatorias.vue';
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
 import enumeraciones from '@/../static/js/enumeraciones'

import moment from 'moment';
export default {
    data(){
        return{
            aspirantes:[],
            aspiranteElegido:{
                idAspiranteElegido:0,
                estadoDeAspirante:'',
                camposFormulario:[],
            },
            rutaDocumentoParaVisor:"",
            filtroConvocatorias:{
                convocatoria:0,
                estado:0,
                categoria:0
            }
        }
    },
    components:{
        FiltroConvocatorias
    },
    methods:{
        llamadoDeApiConsulta: async function(){     
            const METODO_API_AGREGAR = api.conexion+api.convocatorias.sistema.Aspirantes
            +"?IdConvocatoria="+this.filtroConvocatorias.convocatoria
            +"&Estado="+this.filtroConvocatorias.estado
            +"&CatgoriaIdentificador="+this.filtroConvocatorias.categoria;
            axios.get(METODO_API_AGREGAR,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                    comun.SeEstaCargandoInformacion(false);
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {          
                        this.aspirantes = respuesta.data.DatosRegistradosPorAspirantes;
                        this.$nextTick(async () => {
                            await Promise.resolve(this.iniciarTabla(respuesta.data.DatosRegistradosPorAspirantes));
                            await Promise.resolve(this.persistirSwitch());
                        });
                    }
            })
            .catch(excepcion => {
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(excepcion), null, null);
            });
        },
        DescargarReporte: async function(){
        console.log("this.filtroConvocatorias:::",this.filtroConvocatorias)
            const METODO_API_GENERAR_REPORTE = api.conexion+api.convocatorias.sistema.GenerarReporteExcel
            +"IdConvocatoria="+this.filtroConvocatorias.convocatoria
            +"&Estado="+this.filtroConvocatorias.estado
            +"&IdCategoria="+this.filtroConvocatorias.categoria;
            axios.get(METODO_API_GENERAR_REPORTE,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal,false,true))
            .then(respuesta => {
                    comun.SeEstaCargandoInformacion(false);
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                        const blob = new Blob([respuesta.data],{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                        if(window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveBlob(blob, "ReporteAspirantes.xlsx");
                        }
                        else{
                            const elem = window.document.createElement('a');
                            elem.href = window.URL.createObjectURL(blob);
                            elem.download = "ReporteAspirantes.xlsx";       
                            document.body.appendChild(elem);
                            elem.click();        
                            document.body.removeChild(elem);
                        }                   
                    }
            })
            .catch(excepcion => {
                  comun.SeEstaCargandoInformacion(false);
                  console.log(excepcion);
                  comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            });
        },
        accionVerMas:() => {
         return '<button id="btnVerMas" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fa fa-bars"></i></button>';     
        },
        cancelarAccion:async function(row,index){
            const METODO_API_HABILITA_ASPIRANTE = api.convocatorias.sistema.HabilitaAspirante;
            let peticion = {
                IdDelAspirante : row.IdDelAspirante,
                Habilitacion : !row.PuedeEditarInformacionPrincipal
            }
            axios.put(api.conexion + METODO_API_HABILITA_ASPIRANTE,peticion)
            .then(respuesta => {  
                comun.SeEstaCargandoInformacion(false);               
                    if (respuesta.data.SiHayError) {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } 
                    else {
                      this.llamadoDeApiConsulta();
                      comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
            })
            .catch(excepcion => {
                console.log("error",excepcion);
                comun.SeEstaCargandoInformacion(false);          
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            });
        },

        cambiarEstado: async function(aspiranteId,estado){
            const METODO_API_CAMBIAR_ESTADO_ASPIRANTE = api.convocatorias.sistema.CambiarEstatusAspirante;
            let peticion = {
                IdAsistente : aspiranteId,
                IdNuevoEstadoDelAspirante : estado
            }
            axios.put(api.conexion + METODO_API_CAMBIAR_ESTADO_ASPIRANTE,peticion)
            .then(respuesta => {  
                comun.SeEstaCargandoInformacion(false);        
                if (respuesta.data.SiHayError) {
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } 
                else {
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    this.llamadoDeApiConsulta();
                    $('#modal-cambio-estatus').modal("hide");
                }
            })
            .catch(excepcion => {
                console.log("error",excepcion);
                comun.SeEstaCargandoInformacion(false);                 
                comun.mensajeDeAlerta(comun.mensajeDeError(excepcion), null, null);
            });
        },

        verinfomacionDeAspirante:async function(row) {
            this.aspiranteElegido.idAspiranteElegido = row.IdDelAspirante;
            this.aspiranteElegido.estadoDeAspirante = row.EstadoDelAspirante
            this.aspiranteElegido.camposFormulario = row.CamposRegistrados;
            $('#modal-cambio-estatus').modal("show");
        },

        llenarTablaDeContenidos: async function(elementos) {
            this.aspirantes = elementos.map(mapa => {
                let elementosFormateados = mapa;
                elementosFormateados.CamposDeFormulario = mapa.CamposRegistrados,             
                elementosFormateados.EstadoDelAspiranteFormato =(elementosFormateados.EstadoDelAspirante=="Registrado")?`<span class="estadoGrid registradoGrid">Registrado</span>`
                :(elementosFormateados.EstadoDelAspirante=="Aprobado")?`<span class="estadoGrid acceptadoGrid">Aprobado</span>`:`<span class="estadoGrid rechazadoGrid">Rechazado</span>`;            
                elementosFormateados.EstaEditable = {
                    activo: (mapa.PuedeEditarInformacionPrincipal == true),
                    html: `<label id="switch-activo-inactivo-MIC-${ mapa.IdDelAspirante }" class="switch-contenido-activo-MIC">
                            <input id="check-contenido-activo-MIC-${ mapa.IdDelAspirante }" type="checkbox">
                            <div id="slider-activo-inactivo-MIC-${ mapa.IdDelAspirante }" class="slider-contenido-activo-MIC"></div>
                           </label>`
                };
                return elementosFormateados;
            });
        },
          
        iniciarTabla:async function(respuesta) {
            await Promise.resolve(this.llenarTablaDeContenidos(respuesta))
            this.$nextTick(() => {
            $("#tabla-aspirantes").bootstrapTable({  data: this.aspirantes });
            $("#tabla-aspirantes").bootstrapTable('load',this.aspirantes); 
            })
            this.$nextTick(async () => {
                await Promise.resolve(this.persistirSwitch());
            });
            $("td[id^=switch-activo-inactivo-MIC]").addClass('switch-contenido-activo-MIC');
            $("td[id^=slider-activo-inactivo-MIC]").addClass('slider-contenido-activo-MIC');
        },
        persistirSwitch: async function() {
            if(this.aspirantes.length > 0) {
                this.aspirantes.forEach(cObj => {
                    const ID_SWITCH_ACTIVO_CONTENIDO = `check-contenido-activo-MIC-${ cObj.IdDelAspirante }`;
                    $("#" + ID_SWITCH_ACTIVO_CONTENIDO).prop('checked',  cObj.EstaEditable.activo);
                });
            }
        },
        ObtenerFiltros:async function(filtros){
            this.filtroConvocatorias = filtros;
            this.llamadoDeApiConsulta();
        }
 },
    created() {
        this.$nextTick(() => {
           $("#tabla-aspirantes").bootstrapTable({  data: this.aspirantes });      
           $("#tabla-aspirantes").bootstrapTable('load',  this.aspirantes); 
        });

        window.operateEvents = {       
            'click #btnVerMas':(e, value, row, index) => {
            window.addEventListener('click', this.funcionDePrueba);
                this.verinfomacionDeAspirante(row);
            },
            'click #btnCancelar': (e, value, row, index) => {
            },
            'click #btnDesactivar': (e, value, row, index) => {
            },
            'click :checkbox': (e, value, row, index) => {
                this.cancelarAccion(row,index)
                    },
            'click #btnCopiar': (e, value, row, index) => {
            },
        }
    }
}
</script>

<style scoped>
.rechazado{
    font-size: 1.4em;
    font-family: Arial, Helvetica, sans-serif;
    color: #922b21;
    background-color: #d98880;
}
.acceptado{
    font-size: 1.4em;
    font-family: Arial, Helvetica, sans-serif;
    color: #239b56;
    background-color: #abebc6;
}
/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-MIC {
    position: relative;
    top: 5px;
    width: 40px;
    height: 24px;
}

.switch-contenido-activo-MIC input {display:none;}
.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}
.switch-contenido-activo-MIC input:focus + .slider-contenido-activo-MIC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:after
{  
  content:'';
}
</style>

<style >
.estadoGrid{
    font-size: 1em;
    font-family: Arial, Helvetica, sans-serif;
    padding: 3px;
    border: solid 2px;
    border-radius: 2px;
}
.acceptadoGrid{   
    background-color: #abebc6;
    color: #239b56;   
}
.registradoGrid{
    color: #2874a6;
    background-color: #aed6f1;
}
.rechazadoGrid{
    color: #922b21;
    background-color: #d98880;
}
/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-MIC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-contenido-activo-MIC input {display:none;}

.slider-contenido-activo-MIC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-contenido-activo-MIC:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}

.switch-contenido-activo-MIC input:focus + .slider-contenido-activo-MIC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-contenido-activo-MIC:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:after
{  
  content:'';
}
</style>


<style>
/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-MIC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-contenido-activo-MIC input {display:none;}

.slider-contenido-activo-MIC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-contenido-activo-MIC:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}

.switch-contenido-activo-MIC input:focus + .slider-contenido-activo-MIC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-contenido-activo-MIC:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:after
{  
  content:'';
}

/* dropdown tabla de contenidos */
#tabla-resultados-edicion-SICPO .search {
    width: 20rem;
}

#tabla-resultados-edicion-SICPO .dropdown-toggle {
    width: 3.3rem;
}

/* #tabla-resultados-edicion-SICPO .pagination > li > a {
    background-color: white;
    color: #121213;
}

#tabla-resultados-edicion-SICPO > li > a:focus,
#tabla-resultados-edicion-SICPO > li > a:hover,
#tabla-resultados-edicion-SICPO > li > span:focus,
#tabla-resultados-edicion-SICPO .pagination > li > span:hover
{
    color: #111011;
    background-color: #eee;
    border-color: #ddd;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a {
    color: white;
    background-color:  black;
    border: solid 1px #39373d;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a:hover {
    background-color:  black;
    border: solid 1px #39373d;
} */
</style>


// WEBPACK FOOTER //
// src/components/AdministradorConvocatorias/ConsultaConvocatorias/ConsultaConvocatoria.vue